import React, { Component } from "react"
import _ from "lodash"
import ReactCSSTransitionGroup from "react-addons-css-transition-group"
import Socket from "../../lib/socket"
import constants from "../../lib/constants"
import { formatGameIdentifier } from "../../lib/helper"
import { connect } from "react-redux"
import Measure from "react-measure"

import { Col } from "react-bootstrap"
import { AutoScrollView } from "../common"

import QuestionAnswer from "./questionAnswer/view"
import QuestionTextInput from "./questionTextInput/view"
import QuestionImages from "./questionImages/view"

// Styles
import "./styles/questionsWindow.css"
import "../../../src/styles/styles.css"
import drawBanner from "../../../src/assets/drawBanner.jpg"

// Actions
import { updateImageBanner } from "../../../src/entities/ui/actions"

class QuestionsWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayQrCode: false,
      leftBannerDimensions: 0,
    }

    this.renderQuestionWithAnswers = this.renderQuestionWithAnswers.bind(this)
    this.renderQuestionWithTextInput =
      this.renderQuestionWithTextInput.bind(this)
    this.renderGameContainer = this.renderGameContainer.bind(this)

    // Receive websocket event
    if (Socket.isSocket()) {
      Socket.getSocket().addEventListener("message", (event) => {
        const payload = JSON.parse(event.data) || {}

        // Display the QR Code
        if (payload.event === "display_qr") {
          this.setState({ displayQrCode: true })
          setTimeout(() => {
            this.setState({ displayQrCode: false })
          }, 15000)
        }

        // Reveal Voice-poll Answers
        if (payload.event === "answer_reveal_voicepoll") {
          if (
            this.props.currentStep.segment.segment_type ===
            constants.SEGMENT_TYPE_POPULAR_BO_PEEP
          ) {
            this.marquee.scrollToTop()
            this.marquee.stopScrolling()
          }
        }
      })
    }
  }

  componentWillMount() {
    // Foreplay
    if (this.props.presentingForeplay) {
      this.props.updateImageBanner(this.props.currentStep.segment.banner_live)
    }
    // Game
    if (
      this.props.currentStep.step &&
      this.props.currentStep.step.type === "question"
    ) {
      this.props.updateImageBanner(this.props.currentStep.segment.banner_live)
    }
  }

  getFinalAnswerOrder(answers, results, showResults) {
    let finalOrder = answers

    if (
      results &&
      results.length > 1 &&
      results[0].rank !== undefined &&
      showResults
    ) {
      finalOrder = []

      _.each(results, (val) => {
        finalOrder.push(
          _.find(answers, (answer) => {
            return answer.answer_id === parseInt(val.answer_id, 10)
          })
        )
      })
    }

    return finalOrder
  }

  renderBanner() {
    const { identifier } = this.props

    if (this.state.displayQrCode) {
      return (
        <div className="segmentBanner flexColumn flexCenter">
          <span className="fontFamilyBold gameIdentifier fontColorGreen">
            {formatGameIdentifier(identifier)}
          </span>
        </div>
      )
    }

    return <img alt="" src={this.props.imageBanner} className="segmentBanner" />
  }

  renderQuestionWithAnswers() {
    let answerStats = []
    let statsForAnswer = {}
    let isDraw
    let isWinnerAnswer
    let revealed

    const { segment, question } = this.data

    if (this.props.presentingForeplay) {
      // Foreplay
      answerStats = this.props.foreplayStats
      revealed = this.props.presentingForeplay
    } else {
      // Game
      answerStats = this.props.answerStats
      revealed = question.revealed
    }

    const orderedAnswers = _.sortBy(answerStats, "percent")
    const finalOrder = this.getFinalAnswerOrder(
      question.answers,
      answerStats,
      revealed
    )

    let winnerAnswer
    let hasDraw

    if (orderedAnswers.length > 1) {
      winnerAnswer = orderedAnswers[orderedAnswers.length - 1]
      hasDraw =
        winnerAnswer.percent ===
        orderedAnswers[orderedAnswers.length - 2].percent

      if (hasDraw && revealed && answerStats[0].rank === undefined) {
        this.props.updateImageBanner(drawBanner)
      }
    } else if (orderedAnswers.length === 1) {
      winnerAnswer = orderedAnswers[orderedAnswers.length - 1]
    }

    // Don't render answers for first impression
    if (
      !revealed &&
      segment.segment_type === constants.SEGMENT_TYPE_FIRST_IMPRESSION
    ) {
      return <div className={"bgWhite internalBoxAnswers"} />
    }

    return (
      <div className={"bgWhite internalBoxAnswers"}>
        <ReactCSSTransitionGroup
          transitionName="internalBoxAnswersAnimation"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnter={false}
          transitionLeave={false}
        >
          <AutoScrollView
            ref={(ref) => {
              this.marquee = ref
            }}
            childItems={finalOrder}
            renderItem={(answer) => {
              const isDragAndDrop =
                answerStats &&
                answerStats.length > 1 &&
                answerStats[0].rank !== undefined

              if (answerStats && answerStats.length > 0) {
                statsForAnswer = answerStats.find(
                  (stat) => stat.answer_id === answer.answer_id
                )
                isDraw =
                  hasDraw &&
                  statsForAnswer &&
                  statsForAnswer.percent === winnerAnswer.percent
                isWinnerAnswer =
                  !hasDraw &&
                  winnerAnswer &&
                  answer.answer_id === winnerAnswer.answer_id
              }

              return (
                <QuestionAnswer
                  key={answer.answer_id}
                  answer_id={answer.answer_id}
                  answer={answer.label}
                  showResults={revealed && !isDragAndDrop}
                  {...{ isWinnerAnswer, isDraw, statsForAnswer }}
                />
              )
            }}
          />
        </ReactCSSTransitionGroup>
      </div>
    )
  }

  renderQuestionWithImages() {
    const { question } = this.data
    const { answers, revealed, log } = question

    return (
      <div className="bgWhite internalBoxImages">
        <QuestionImages
          answers={answers}
          log={log}
          answerStats={this.props.answerStats}
          showResults={revealed}
          players={this.props.players}
        />
      </div>
    )
  }

  renderQuestionWithTextInput() {
    let canDisplay = true
    let finalAnswers = []

    const { answerStats } = this.props
    const { segment, question } = this.data

    const { show_answer } = question.option

    if (show_answer === false && !question.revealed) {
      canDisplay = false
    }

    if (
      segment.segment_type === constants.SEGMENT_TYPE_POPULAR_BO_PEEP &&
      question.revealed
    ) {
      finalAnswers.push(
        ..._.orderBy(
          answerStats,
          (stat) => {
            return stat.popularity ? stat.popularity.length : 0
          },
          "desc"
        )
      )
    } else {
      finalAnswers.push(...answerStats)
    }

    return (
      <div className="bgWhite internalBoxTextInput">
        {canDisplay && (
          <ReactCSSTransitionGroup
            transitionName="textInputAnswer"
            transitionAppear={true}
            transitionAppearTimeout={400}
            transitionEnterTimeout={400}
            transitionLeaveTimeout={400}
          >
            <AutoScrollView
              ref={(ref) => {
                this.marquee = ref
              }}
              childItems={finalAnswers}
              renderItem={(submission) => {
                return (
                  <QuestionTextInput
                    key={submission.submission_id}
                    answer_text={submission.answer_text}
                    popularity={submission.popularity || []}
                  />
                )
              }}
            />
          </ReactCSSTransitionGroup>
        )}
      </div>
    )
  }

  renderGameContainer() {
    const { gameState } = this.props
    const { question, step } = this.data

    if (
      step.type === "question" ||
      gameState.game_stage_id === constants.GAME_STAGE_COMMENCING
    ) {
      switch (question.question_type_name) {
        // Elimination Poll
        case "elimination":
          return this.renderQuestionWithImages()
        // Choice || Sequence Poll
        case "choice":
        case "sequence":
          return this.renderQuestionWithAnswers()
        // Voice Poll
        case "voice":
          return this.renderQuestionWithTextInput()
        default:
          break
      }
    }
  }

  renderGameIdentifier() {
    const { identifier } = this.props

    if (identifier && !this.state.displayQrCode) {
      return (
        <span className="fontFamilyBold gameIdentifierBadge">
          {formatGameIdentifier(identifier)}
        </span>
      )
    }
  }

  render() {
    const { currentStep, presentingForeplay } = this.props

    let shouldRenderTitle = true

    // Assign the current step as data.
    this.data = currentStep

    if (!currentStep.step) {
      return null
    }

    if (!presentingForeplay) {
      if (currentStep.step.type === "question") {
        if (
          !currentStep.question.revealed &&
          currentStep.segment.segment_type ===
            constants.SEGMENT_TYPE_FIRST_IMPRESSION
        ) {
          shouldRenderTitle = false
        }
      }
    }

    return (
      <div className="questionsWindow">
        <Measure
          onMeasure={(dimensions) => {
            this.setState({ leftBannerDimensions: dimensions })
          }}
        >
          <Col xs={12} sm={6} className="leftBanner p0">
            <Col xs={10} md={9} className="questionContainer">
              <ReactCSSTransitionGroup
                transitionName="questionTitleAnimation"
                transitionAppear={true}
                transitionAppearTimeout={500}
                transitionEnter={false}
                transitionLeave={false}
              >
                {this.renderGameIdentifier()}
                <h3
                  className="fontFamilyBold fontColorOrange titleSegment"
                  style={{
                    color: this.data.segment ? this.data.segment.color : "#000",
                  }}
                >
                  {this.data.segment.name}
                </h3>
                <h3 className="fontFamilyBold fontColorBlack questionTitle">
                  {shouldRenderTitle && this.data.question.title
                    ? this.data.question.title
                    : ""}
                </h3>
              </ReactCSSTransitionGroup>
            </Col>
            {this.renderBanner()}
          </Col>
        </Measure>
        <Col xs={12} sm={6} className="rightBanner bgLightGray">
          {this.renderGameContainer()}
        </Col>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    gameState,
    currentStep,
    presentingForeplay,
    currentForeplayIndex,
    foreplayStats,
    answerStats,
    players,
    identifier,
    showResults,
  } = state.game.currentGame

  const { imageBanner } = state.ui
  const segment = state.ui.currentSegment

  return {
    gameState,
    currentStep,
    identifier,
    players,
    presentingForeplay,
    currentForeplayIndex,
    foreplayStats,
    answerStats,
    showResults,
    imageBanner,
    segment,
  }
}

export default connect(mapStateToProps, {
  updateImageBanner,
})(QuestionsWindow)



// WEBPACK FOOTER //
// ./src/components/questionsWindow/view.js